import React, { useState } from 'react'
import { Button, Table, Typography, Space, Image } from 'antd'
import { paymentData } from '../../../Data';
import { ActionButton, AlertModal, PaymentMethodDrawer } from '../..';

const { Text } = Typography;
const PaymentTable = ({setVisible,visible}) => {

    const [deleteitem,setDeleteItem] = useState(false)
    const [ edititem, setEditItem ] = useState(null)

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Name</Text>,
            dataIndex: 'name',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Payment Method</Text>,
            dataIndex: 'paymentMethod',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Account No.</Text>,
            dataIndex: 'accountNo'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title='Edit Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/edit.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setVisible(true);setEditItem(row)}}
                    />
                    <ActionButton
                        title='Delete Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.title})}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            <Table
                size='large'
                columns={columns}
                dataSource={paymentData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1200 }}
                pagination={{
                hideOnSinglePage: true,
                    total: 12,
                    // pageSize: pagination?.pageSize,
                    // defaultPageSize: pagination?.pageSize,
                    // current: pagination?.pageNo,
                    // size: "default",
                    // pageSizeOptions: ['10', '20', '50', '100'],
                    // onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                    showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                }}
            />

            <PaymentMethodDrawer 
                visible={visible}
                edititem={edititem}
                onClose={()=>{setVisible(false);setEditItem(null)}}
            />
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { PaymentTable }